// extracted by mini-css-extract-plugin
export default {"loader":"LogoLoader_loader__cJE9m","spin":"LogoLoader_spin__M66BR","content":"LogoLoader_content__2WXzK","logo":"LogoLoader_logo__cSath","text":"LogoLoader_text__lnKlb"};